import { render, staticRenderFns } from "./closeCase.vue?vue&type=template&id=d54f1a42"
import script from "./closeCase.vue?vue&type=script&lang=js"
export * from "./closeCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports